var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2152_5584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0085 1.8335C16.0685 1.8335 20.166 5.94016 20.166 11.0002C20.166 16.0602 16.0685 20.1668 11.0085 20.1668C5.93935 20.1668 1.83268 16.0602 1.83268 11.0002C1.83268 5.94016 5.93935 1.8335 11.0085 1.8335ZM14.2077 7.3335C13.4468 7.3335 12.8327 7.94766 12.8327 8.7085C12.8327 9.46933 13.4468 10.0835 14.2077 10.0835C14.9685 10.0835 15.5827 9.46933 15.5827 8.7085C15.5827 7.94766 14.9685 7.3335 14.2077 7.3335ZM10.9993 16.5002C13.0893 16.5002 14.8677 14.9785 15.5827 12.8335H6.41602C7.13102 14.9785 8.90935 16.5002 10.9993 16.5002ZM7.79102 10.0835C8.55185 10.0835 9.16602 9.46933 9.16602 8.7085C9.16602 7.94766 8.55185 7.3335 7.79102 7.3335C7.03018 7.3335 6.41602 7.94766 6.41602 8.7085C6.41602 9.46933 7.03018 10.0835 7.79102 10.0835Z",
    fill: "#D7C0FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2152_5584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "matrix(-1 0 0 1 22 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomEmoji);
export default __webpack_public_path__ + "static/media/custom-emoji.bcbe3c6bc0b7b88c089a15b9afbe40ce.svg";
export { ForwardRef as ReactComponent };